import { ActionReducerMap } from '@ngrx/store';
import { CommentsResourcesActionTypes } from './actions';

export function comments (state = [], { type, payload }: any) {
  switch (type) {
    case CommentsResourcesActionTypes.GET_COMMENTS_RESOURCES_SUCCESS:
      return payload.res;
    case CommentsResourcesActionTypes.SET_COMMENTS_RESOURCES_SAVED_SUCCESS:
      return state.concat(payload)
    default:
      return state;
  }
}

export function loading (state = false, { type, payload}: any) {
  switch (type) {
    case CommentsResourcesActionTypes.LOADING_COMMENTS:
      return payload;
    default:
      return state;
  }
}

export interface State {
  comments: any;
  loading: boolean;
}

export const reducers: ActionReducerMap<State> = {
  comments,
  loading
};
